import axios from "axios";
import store from "@/store";

const instance = axios.create({
    baseURL:process.env.VUE_APP_BACK_URL ?? "http://198.244.200.15:5003/api",
});

export default function ({ method = 'GET', url = "", data = [], mulitpart = false }) {

    return new Promise((resolve, reject) => {
        instance({
            method,
            url,
            data,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": mulitpart ? 'multipart/form-data' : 'application/json'
            }
        }).then((res) => {
            return resolve(res);
        }).catch((err) => {
            if (err.response?.status == 401 || err.response?.status == 403) {
                store.dispatch("auth/user/logoutUser", null, { root: true })
            }
            reject(err)
        })
    });
}
